import { render, staticRenderFns } from "./ManageDataset.vue?vue&type=template&id=31358699&"
import script from "./ManageDataset.vue?vue&type=script&lang=js&"
export * from "./ManageDataset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports